import React, { useEffect } from "react";
import { Users, Trash2, Truck } from "lucide-react";

const CounterSection = () => {
  
  // --- Animation Logic (Unchanged) ---
  useEffect(() => {
    const counters = document.querySelectorAll(".count-number");

    counters.forEach((counter) => {
      const duration = parseInt(counter.dataset.duration) || 2000;
      const start = parseInt(counter.dataset.start) || 0;
      const end = parseInt(counter.dataset.end) || 0;
      const range = end - start;
      let startTime = null;

      function animate(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const currentValue = Math.floor(progress * range + start);

        counter.innerText = currentValue.toLocaleString();

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    });
  }, []);

  return (
    <>
      <style>{`
        /* Main Section Background */
        .wastix-counter-section {
          background-color: #44a028; /* The specific green from screenshot */
          padding: 80px 0;
          color: white;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          width: 100%;
        }

        .wastix-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px;
        }

        /* Individual Box Styling */
        .counter-box {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: center;
          position: relative;
        }

        /* Vertical Divider Lines */
        .counter-box:not(:last-child)::after {
          content: '';
          position: absolute;
          right: 0;
          height: 70%;
          width: 1px;
          background-color: rgba(255, 255, 255, 0.3);
        }

        /* Icon Circle Styling */
        .icon-wrapper {
          width: 80px;
          height: 80px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 25px;
          flex-shrink: 0;
        }

        .content-wrapper {
          display: flex;
          flex-direction: column;
        }

        /* Number Styling (Serif Font) */
        .count-row {
          display: flex;
          align-items: baseline;
          margin-bottom: 5px;
          line-height: 1;
        }

        .count-number {
          font-family: 'Georgia', 'Times New Roman', serif; /* Serif for numbers */
          font-size: 3.5rem;
          font-weight: 700;
        }

        .suffix {
          font-family: 'Georgia', 'Times New Roman', serif;
          font-size: 2.5rem;
          margin-left: 4px;
        }

        /* Label Styling */
        .counter-label {
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0;
          opacity: 0.9;
        }

        /* Mobile Responsiveness */
        @media (max-width: 768px) {
          .wastix-container {
            flex-direction: column;
            gap: 40px;
          }
          
          .counter-box {
            width: 100%;
            justify-content: flex-start;
            border-right: none;
          }

          .counter-box:not(:last-child)::after {
            display: none; /* Hide vertical lines on mobile */
          }
        }
      `}</style>

      <section className="wastix-counter-section">
        <div className="wastix-container">

          {/* Box 1 */}
          <div className="counter-box">
            <div className="icon-wrapper">
              <Users size={32} color="white" />
            </div>

            <div className="content-wrapper">
              {/* Number on Top */}
              <div className="count-row">
                <span
                  className="count-number"
                  data-duration="2000"
                  data-start="0"
                  data-end="20"
                >
                  0
                </span>
                <span className="suffix">k</span>
              </div>
              {/* Text Below */}
              <h4 className="counter-label">Satisfied & Happy Clients</h4>
            </div>
          </div>

          {/* Box 2 */}
          <div className="counter-box">
            <div className="icon-wrapper">
              <Trash2 size={32} color="white" />
            </div>

            <div className="content-wrapper">
              <div className="count-row">
                <span
                  className="count-number"
                  data-duration="2000"
                  data-start="0"
                  data-end="80"
                >
                  0
                </span>
                <span className="suffix">+</span>
              </div>
              <h4 className="counter-label">Total Industries Served</h4>
            </div>
          </div>

          {/* Box 3 */}
          <div className="counter-box">
            <div className="icon-wrapper">
              <Truck size={32} color="white" />
            </div>

            <div className="content-wrapper">
              <div className="count-row">
                <span
                  className="count-number"
                  data-duration="2000"
                  data-start="0"
                  data-end="205"
                >
                  0
                </span>
                <span className="suffix">kg </span>
                <span>
                  Tons
                </span>
              </div>
              <h4 className="counter-label">Waste Picked & Dispose</h4>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default CounterSection;